<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运营商申请售后</el-breadcrumb-item>
      <el-breadcrumb-item>申请维修</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords.status" placeholder="请选择" class="select">
              <el-option label="请选择订单状态" value="-1"></el-option>
              <el-option label="已创建" value="0"></el-option>
              <el-option label="已审核" value="1"></el-option>
              <el-option label="已发货" value="2"></el-option>
              <el-option label="仓库确认收货" value="3"></el-option>
              <el-option label="仓库回寄" value="4"></el-option>
              <el-option label="运营商确认收货" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.bomsn" placeholder="请选择产品" class="select2">
              <el-option label="请选择产品名称" value=""></el-option>
              <el-option
                v-for="item in optionsproduct" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->
        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Statuss" label="状态" min-width="6%"></el-table-column>
          <el-table-column prop="Productname" label="产品名称" min-width="4%"></el-table-column>
          <el-table-column prop="Jigouname" label="机构名称" min-width="7%"></el-table-column>
          <el-table-column prop="Cardnumber" label="设备编号" min-width="7%"></el-table-column>
          <el-table-column prop="Logisticsname1" label="物流公司(发货给仓库)" min-width="5%"></el-table-column>
          <el-table-column prop="Logisticsid1" label="物流单号(发货给仓库)" min-width="5%"></el-table-column>
          <el-table-column prop="Dlsaddress" label="运营商收货地址" min-width="5%"></el-table-column>
          <el-table-column prop="Dlsname" label="运营商联系人姓名" min-width="5%"></el-table-column>
          <el-table-column prop="Dlsphone" label="运营商联系人手机" min-width="5%"></el-table-column>
          <el-table-column prop="Logisticsname2" label="物流公司(发货给运营商)" min-width="5%"></el-table-column>
          <el-table-column prop="Logisticsid2" label="物流单号(发货给运营商)" min-width="5%"></el-table-column>
          <el-table-column prop="Weixiutypename" label="维修类型" min-width="5%"></el-table-column>
          <el-table-column prop="Beizhudls" label="运营商备注" min-width="8%"></el-table-column>
          <el-table-column prop="Beizhuck" label="仓管备注" min-width="8%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="8%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="8%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Status == 0 && SubRule_ErpDlsReturnsXiu_Review" @click="clickReview(scope.row)">审核换货申请</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Status == 1 && SubRule_ErpDlsReturnsXiu_Send" @click="clicksend(scope.row)">运营商发货</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Status == 2 && SubRule_ErpDlsReturnsXiu_SendOk" @click="clicksendOk(scope.row)">仓库确认收货</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Status == 3 && SubRule_ErpDlsReturnsXiu_ReSend" @click="clickReSend(scope.row)">仓库回寄</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Status == 4 && SubRule_ErpDlsReturnsXiu_ReSendOk" @click="clickReSendOk(scope.row)">运营商确认回寄</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->
        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 运营商发货弹出框 -->
    <el-dialog title="运营商发货" :visible.sync="Senddialog" width="30%" :close-on-click-modal="false">
      <el-form :model="SendForm" ref="SendFormRef" label-width="70px">
        <el-form-item label="物流公司" class="addAdminForm">
          <el-input v-model="SendForm.logisticsname1" placeholder="请输入物流公司(发货给仓库)"></el-input>
        </el-form-item>
        <el-form-item label="物流单号" class="addAdminForm">
          <el-input v-model="SendForm.logisticsid1" placeholder="请输入物流单号(发货给仓库)"></el-input>
        </el-form-item>
        <el-form-item label="收货地址" class="addAdminForm">
          <el-input v-model="SendForm.dlsaddress" placeholder="请输入运营商收货地址"></el-input>
        </el-form-item>
        <el-form-item label="姓名" class="addAdminForm">
          <el-input v-model="SendForm.dlsname" placeholder="请输入运营商联系人姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机" class="addAdminForm">
          <el-input v-model="SendForm.dlsphone" placeholder="请输入运营商联系人手机"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksaveSend">发货</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 运营商发货弹出框 end -->

    <!-- 仓库回寄弹出框 -->
    <el-dialog title="仓库回寄" :visible.sync="ReSenddialog" width="30%" :close-on-click-modal="false">
      <el-form :model="ReSendForm" ref="ReSendFormRef" label-width="70px">
        <el-form-item label="物流公司" class="addAdminForm">
          <el-input v-model="ReSendForm.logisticsname2" placeholder="物流公司(发货给运营商)"></el-input>
        </el-form-item>
        <el-form-item label="物流单号" class="addAdminForm">
          <el-input v-model="ReSendForm.logisticsid2" placeholder="物流单号(发货给运营商)"></el-input>
        </el-form-item>
        <el-form-item label="备注" class="addAdminForm">
          <el-input type="textarea" v-model="ReSendForm.beizhuck" placeholder="请输入备注" rows="5"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksaveReSend">发货</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 仓库回寄弹出框 end -->

    <!-- 申请维修 start -->
    <el-tab-pane label="申请维修" v-if="SubRule_ErpDlsReturnsXiu_Apply" name="second">
      <el-form :model="addForm" ref="addFormRef" label-width="70px">
        <el-form-item label="产品名称" class="addAdminForm">
            <el-select v-model="addForm.bomsn" placeholder="请选择产品" class="select2">
              <el-option
                v-for="item in optionsproduct" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="保修卡号" class="addAdminForm">
          <el-input v-model="addForm.cardnumber" placeholder="请输入保修卡号后8位,然后点击校验按钮"></el-input>
          <el-button type="success" plain @click="apicheckcardnumber">校验</el-button>
        </el-form-item>
        <el-form-item label="维修类型" class="addAdminForm">
            <el-select v-model="addForm.weixiutypeid" placeholder="请选择维修类型" class="select2">
              <el-option
                v-for="item in optionsweixiutype" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="备注" class="addAdminForm">
          <el-input type="textarea" v-model="addForm.beizhudls" placeholder="请输入备注" rows="5"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">申请</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 申请维修 end -->
  </el-tabs>
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou
  },
  name: 'MyErpDlsReturnsXiu',
  data () {
    return {
      activeName: 'first',
      optionsproduct: [],
      optionsweixiutype: [],
      addForm: {
        bomsn: '',
        weixiutypeid: '7',
        cardnumber: '',
        beizhudls: ''
      },
      timer: '',
      // 查询
      keywords: {
        status: '-1',
        bomsn: '',
        jigouid: '-1',
        jigouname: ''
      },
      dataList: [],
      dataListnum: 0,
      Senddialog: false,
      SendForm: {
        id: '',
        logisticsname1: '',
        logisticsid1: '',
        dlsaddress: '',
        dlsname: '',
        dlsphone: ''
      },
      ReSenddialog: false,
      ReSendForm: {
        id: '',
        logisticsname2: '',
        logisticsid2: '',
        beizhuck: ''
      },
      selectedPageNo: 1,
      SubRule_ErpDlsReturnsXiu_Apply: false,
      SubRule_ErpDlsReturnsXiu_Review: false,
      SubRule_ErpDlsReturnsXiu_Send: false,
      SubRule_ErpDlsReturnsXiu_SendOk: false,
      SubRule_ErpDlsReturnsXiu_ReSend: false,
      SubRule_ErpDlsReturnsXiu_ReSendOk: false
    }
  },
  mounted () {
    this.apiGetWorkprojectList()
    this.apiGetDlsReturnsXiunum()
    this.apiGetDlsReturnsXiulist()
    this.apiGetweixiutype()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsReturnsXiu_Apply', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsReturnsXiu_Apply = true
      }
    })

    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsReturnsXiu_Review', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsReturnsXiu_Review = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsReturnsXiu_Send', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsReturnsXiu_Send = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsReturnsXiu_SendOk', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsReturnsXiu_SendOk = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsReturnsXiu_ReSend', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsReturnsXiu_ReSend = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsReturnsXiu_ReSendOk', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsReturnsXiu_ReSendOk = true
      }
    })
  },
  methods: {
    clickReview (row) {
      this.$confirm('是否同意运营商的维修申请?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiEditDlsReturnsXiushenhe(row.Id)
      })
    },
    clicksend (row) {
      this.Senddialog = true
      this.SendForm.id = row.Id
      this.SendForm.logisticsname1 = ''
      this.SendForm.logisticsid1 = ''
      this.SendForm.dlsaddress = ''
      this.SendForm.dlsname = ''
      this.SendForm.dlsphone = ''
    },
    clicksendOk (row) {
      this.$confirm('是否确认收货?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiEditDlsReturnsXiuSendOk(row.Id)
      })
    },
    clickReSend (row) {
      this.ReSenddialog = true
      this.ReSendForm.id = row.Id
      this.ReSendForm.logisticsname2 = ''
      this.ReSendForm.logisticsid2 = ''
    },
    clickReSendOk (row) {
      this.$confirm('是否确认收货?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiEditDlsReturnsXiuReSendOk(row.Id)
      })
    },
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clickadd () {
      if (!this.addForm.cardnumber) {
        this.$alert('请输入保修卡号', '提示')
        return
      }
      if (!this.addForm.weixiutypeid) {
        this.$alert('请选择维修类型', '提示')
        return
      }
      this.apiAddDlsReturnsXiu()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clicksaveSend () {
      if (!this.SendForm.logisticsname1) {
        this.$alert('请输入物流公司(发货给仓库)', '提示')
        return
      }
      if (!this.SendForm.logisticsid1) {
        this.$alert('请输入物流单号(发货给仓库)', '提示')
        return
      }
      if (!this.SendForm.dlsaddress) {
        this.$alert('请输入运营商收货地址', '提示')
        return
      }
      if (!this.SendForm.dlsname) {
        this.$alert('请输入运营商联系人姓名', '提示')
        return
      }
      if (!this.SendForm.dlsphone) {
        this.$alert('请输入运营商联系人手机', '提示')
        return
      }
      this.apiEditDlsReturnsXiuSend()
    },
    clicksaveReSend () {
      if (!this.ReSendForm.logisticsname2) {
        this.$alert('请输入物流公司', '提示')
        return
      }
      if (!this.ReSendForm.logisticsid2) {
        this.$alert('请输入物流单号', '提示')
        return
      }
      this.apiEditDlsReturnsXiuReSend()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetDlsReturnsXiunum()
      this.apiGetDlsReturnsXiulist()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetDlsReturnsXiulist()
    },
    apiGetWorkprojectList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkprojectList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.optionsproduct = []
            response.data.List.filter((item1, i1) => {
              if (item1.Bomtype == 1) {
                that.optionsproduct.push({ value: item1.Bomsn, label: item1.Name })
              }
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetweixiutype: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getweixiutype, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.optionsweixiutype = []
            response.data.List.filter((item1, i1) => {
              that.optionsweixiutype.push({ value: item1.Id, label: item1.Name })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetDlsReturnsXiunum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        status: that.keywords.status,
        bomsn: that.keywords.bomsn,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetDlsReturnsXiunum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetDlsReturnsXiulist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        status: that.keywords.status,
        bomsn: that.keywords.bomsn,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetDlsReturnsXiulist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddDlsReturnsXiu: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: this.addForm.bomsn,
        cardnumber: this.addForm.cardnumber,
        weixiutypeid: this.addForm.weixiutypeid,
        beizhudls: this.addForm.beizhudls
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddDlsReturnsXiu, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetDlsReturnsXiunum()
            that.apiGetDlsReturnsXiulist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditDlsReturnsXiushenhe: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditDlsReturnsXiushenhe, Qs.stringify(data))
        .then(function (response) {
          that.apiGetDlsReturnsXiulist()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditDlsReturnsXiuSend: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.SendForm.id,
        logisticsname1: this.SendForm.logisticsname1,
        logisticsid1: this.SendForm.logisticsid1,
        dlsaddress: this.SendForm.dlsaddress,
        dlsname: this.SendForm.dlsname,
        dlsphone: this.SendForm.dlsphone
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditDlsReturnsXiuSend, Qs.stringify(data))
        .then(function (response) {
          that.apiGetDlsReturnsXiulist()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.Senddialog = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditDlsReturnsXiuSendOk: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditDlsReturnsXiuSendOk, Qs.stringify(data))
        .then(function (response) {
          that.apiGetDlsReturnsXiulist()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditDlsReturnsXiuReSend: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.ReSendForm.id,
        logisticsname2: this.ReSendForm.logisticsname2,
        logisticsid2: this.ReSendForm.logisticsid2,
        beizhuck: this.ReSendForm.beizhuck
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditDlsReturnsXiuReSend, Qs.stringify(data))
        .then(function (response) {
          that.apiGetDlsReturnsXiulist()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.ReSenddialog = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditDlsReturnsXiuReSendOk: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditDlsReturnsXiuReSendOk, Qs.stringify(data))
        .then(function (response) {
          that.apiGetDlsReturnsXiulist()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apicheckcardnumber: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        cardnumber: that.addForm.cardnumber
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_CheckCardnumberJigou, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.addForm.cardnumber = response.data.Cardnumber
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
